import { render, staticRenderFns } from "./PlaceholdersCreate.vue?vue&type=template&id=92bd37fa&"
import script from "./PlaceholdersCreate.vue?vue&type=script&lang=js&"
export * from "./PlaceholdersCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports